import { state, getters } from './types';

export default {
  [getters.CHANNELS](s) {
    return s[state.CHANNELS];
  },
  [getters.CHANNELS_BY_COLLECTION](s) {
    return s[state.CHANNELS_BY_COLLECTION];
  },
  [getters.USERS_BY_ID](s) {
    return s[state.USERS_BY_ID];
  },
  [getters.MESSAGES](s) {
    return s[state.MESSAGES];
  },
  [getters.ACTIVE_CHANNEL](s) {
    return s[state.ACTIVE_CHANNEL];
  },
  [getters.FEED](s) {
    return s[state.FEED];
  },
  [getters.UNREAD_FEED](s) {
    return s[state.FEED].filter(m => {
      const lastRead = s[state.CHANNEL_READ_AT][m.channel_id];
      if (!lastRead) return true;
      return new Date(m.date_generated) > new Date(lastRead);
    });
  },
  [getters.CHAT_PANEL_OPEN](s) {
    return s[state.CHAT_PANEL_OPEN];
  },
  [getters.CHAT_PANEL_WIDTH](s) {
    return s[state.CHAT_PANEL_WIDTH];
  },
  [getters.ACTIVE_COLLECTION](s) {
    return s[state.ACTIVE_COLLECTION];
  },
  [getters.COLLECTION_MEMBERS](s) {
    return s[state.COLLECTION_MEMBERS];
  },
  [getters.NEW_CONVERSATION_MODE](s) {
    return s[state.NEW_CONVERSATION_MODE];
  },
  [getters.SCROLL_TARGET_MESSAGE_ID](s) {
    return s[state.SCROLL_TARGET_MESSAGE_ID];
  },
};
